import { Typography } from "@mui/material";

export const BillSummaryColumn = [
  {
    title: "Name",
    field: "category_name",
    align: "left",
    render: (rowData) =>
      rowData.category_name && (
        <Typography varient="p" fontSize={"14px"}>
          {rowData.category_name}
        </Typography>
      ),
  },
  {
    title: "Bill Amount",
    field: "bill_requested_amount",
    align: "left",
    render: (rowData) =>
      rowData && rowData.bill_requested_amount !== null ? (
        <Typography varient="p" fontSize={"14px"}>
          &#x20b9; {Math.trunc(rowData.bill_requested_amount)}
        </Typography>
      ) : (
        <Typography varient="p" fontSize={"14px"} maxWidth={"100px"}>
          &#x20b9; 0
        </Typography>
      ),
  },
  {
    title: "Tariff Amount",
    field: "tariff_admissible_amount",
    align: "left",
    render: (rowData) =>
      rowData && rowData.tariff_admissible_amount !== null ? (
        <Typography varient="p" fontSize={"14px"}>
          &#x20b9; {Math.trunc(rowData.tariff_admissible_amount)}
        </Typography>
      ) : (
        <Typography varient="p" fontSize={"14px"} maxWidth={"100px"}>
          &#x20b9; 0
        </Typography>
      ),
  },
  {
    title: "Policy Approved Amount",
    field: "benefit_group_admissible_amount",
    align: "left",
    render: (rowData) =>
      rowData && rowData.benefit_group_admissible_amount !== null ? (
        <Typography varient="p" fontSize={"14px"}>
          &#x20b9; {Math.trunc(rowData.benefit_group_admissible_amount)}
        </Typography>
      ) : (
        <Typography varient="p" fontSize={"14px"} maxWidth={"100px"}>
          &#x20b9; 0
        </Typography>
      ),
  },

  {
    title: "Savings",
    align: "left",
    render: (rowData) =>
      rowData && rowData.savings !== null ? (
        <Typography varient="p" fontSize={"14px"}>
          &#x20b9; {Math.trunc(rowData.savings)}
        </Typography>
      ) : (
        <Typography varient="p" fontSize={"14px"} maxWidth={"100px"}>
          &#x20b9; 0
        </Typography>
      ),
  },
  // {
  //   title: "Remarks",
  //   field: "remarks",
  //   align: "left",
  //   render: (rowData) =>
  //     rowData.remarks !== undefined || null ? (
  //       <Typography varient="p" fontSize={"14px"}>
  //         {rowData.remarks}
  //       </Typography>
  //     ) : (
  //       <Typography varient="p" fontSize={"14px"} maxWidth={"100px"}>
  //         NA
  //       </Typography>
  //     ),
  // },
];
